import { useGetPresentersList } from '@/hooks/presenter/useGetPresentersList'; // do not shortcut this import
import { useAgentEditorStore } from '@/state/root';
import { ImageType, PresenterUsecase } from '@d-id/types';
import { getDefaultAgentPresenter } from '../utils';

export const useGetCurrentAgentsPresenter = (fallbackToDefaultPresenter: boolean = true, presenterType?: ImageType) => {
    const agentEditorStore = useAgentEditorStore();
    const isAgentV2 = agentEditorStore.inputAgent.id?.includes('v2') ?? false;

    const usecase = PresenterUsecase.Agent;
    const { data: presenters } = useGetPresentersList({ usecase, presenterType });
    const defaultPresenter = getDefaultAgentPresenter(presenters);
    if (presenters) {
        const filteredPresenter = presenters.filter(presenter => presenter.id === agentEditorStore.selectedPresenter);

        if (filteredPresenter.length > 0) {
            const withBg = filteredPresenter.find(presenter => presenter.poster?.includes('with_background')) ?? filteredPresenter[0];
            const v1 = filteredPresenter.find(presenter => !presenter.poster?.includes('v2_')) ?? filteredPresenter[0];

            return isAgentV2 ? withBg ?? v1 : v1;
        }
        return filteredPresenter[0] ?? (fallbackToDefaultPresenter ? defaultPresenter : undefined);
    }
};
